
import React, { Component } from 'react';
import OrderItem from './OrderItem';
import PendingQueue from '../components/merchant/components/BackgroundQueue/PendingQueue';
import PrinterFunction from './PrinterFunction';

export const getFinalBillCashValue = (bill) => {
    let cash = (bill.cash * 1).toFixed(2)
    if (bill.decimalflag) {
        cash = (parseFloat(bill.cash + "." + bill.decimal) * 1).toFixed(2)
    }
    return cash
}

class MerchantAppData {
    constructor() {
        if (!MerchantAppData.instance) {
            this.data = null
            MerchantAppData.instance = this
        }
        this.confirmModalRef = React.createRef()
        return MerchantAppData.instance;
    }
    init(app) {
        if (this.data == null) {
            this.data = app
            this.context = app
            Object.freeze(MerchantAppData.instance);

            PendingQueue.init(this)
        }
    }
    getTotalOrderPrice = () => {
        let adminOrders = this.context.state.adminOrders.filter(order => order.table_session_id == this.context.state.currentSession.id)
        let total = adminOrders.length == 0 ? 0 : adminOrders.map((order) => (order.order_status == "void" ? 0 : order.order_total))
            .reduce((order1, order2) => {return (parseFloat(order1) || 0) + (parseFloat(order2) || 0)}, 0)

        let gotTax = (this.context.state.merchant.tax_no != null)? true : false;
        let final = gotTax ? (Math.round((total * 1.06) * 20) / 20).toFixed(2) : total.toFixed(2);
        return final
    }
    setState = (state, callback) => {
        this.context.setState(state, callback)
    }
    getSession() {
        if (this.context.state.sessions == null) {
            return null
        }
        return this.context.state.currentSession
    }
    payBill = (callback, options = {}) => {
        if (options) {
            options.is_auto_close_bill = true
        }
        this.confirmAllOrderAPI(this.confirmModalRef.current, options, callback)
    }
    confirmAllOrderAPI = (confirmDialog, options, callback) => {
        options = options || {}

        let me = this
        // confirmDialog.isLoading(true)

        let orders = []
        let newOrders = []
        let isDraft = false
        let adminOrders = this.context.state.adminOrders
        for (var i = 0; i < adminOrders.length; i++) {
            let order = adminOrders[i]
            if (order.order_status == "void" || order.table_session_id != this.context.state.currentSession.id) {
                continue
            }

            if (order.order_status == "draft") {
                newOrders.push(order)
                //Update order status to confirm
                order.order_status = "accepted"
                isDraft = true
            }

            orders.push(order)
        }

        options.is_auto_close_bill = !!options.is_auto_close_bill ? 1 : 0
        options.orders = JSON.parse(JSON.stringify(orders))

        let extraDataFromOptions = {
            is_auto_close_bill: options.is_auto_close_bill,
            earn_point: options.earn_point,
            redeem_point: options.redeem_point,
            membership_id: options.membership_id,
            other_discount: options.other_discount,
            other_discount_type: options.other_discount_type,
            bill_merchant_admin_id: options.bill_merchant_admin_id,
            quick_settlement: options.quick_settlement,
            counter_id: options.counter_id || (this.context.state.counter && this.context.state.counter.id),
        }

        let session = this.getSession()
        let table = this.context.state.tables.find((item) => item.id == session.table_id)

        if (isDraft) { //Confirm order 1st and then only close bill

            let bill = this.context.state.bill
            let data = {}
            data.payment_type_id = bill.payment_type_id
            data.ref_no = bill.ref_no || null
            data.discount = bill.discount.value

            const finalData = {
                ...data,
                ...extraDataFromOptions,
                orders: JSON.parse(JSON.stringify(orders)),
                newOrders: JSON.parse(JSON.stringify(newOrders)),
                is_auto_close_bill: options.is_auto_close_bill,
                is_auto_print_receipt: options.is_auto_print_receipt,
                is_without_close_table: options.is_without_close_table,
                discount: this.context.state.bill.discount.value,
                skip_print: (options && options.skip_print) ? 1 : 0,
                cash: getFinalBillCashValue(this.context.state.bill),
                cash_balance: this.context.state.bill.cash_balance,
                service_charge: this.context.state.bill.service_charge,
                service_charge_percent: this.context.state.bill.service_charge_percent,
            }

            const isDisableRetry = window.debugSetting && window.debugSetting.admin_order && window.debugSetting.admin_order.disable_retry
            let a = {
                action: (retryCount) => {
                    return new Promise((resolve, reject) => {
                        $.ajax({
                            url: '/merchants/orders',
                            type: 'POST',
                            contentType: "application/json",
                            processData: false,
                            data: JSON.stringify({...finalData, retry_count: retryCount}),
                            success: (orders) => {
                                console.log(moment().format('HH:mm:ss.SSS'), "MerchantAppData.confirmAllOrderAPI.completed")
                                callback && callback(orders)
                                $(document).trigger("MerchantAppData.confirmAllOrderAPI.completed")
                                resolve()
                            }
                        })
                        .fail((jqXHR) => {
                            let message = 'Fail to place order'
                            if (jqXHR.responseText) {
                                let json = JSON.parse(jqXHR.responseText);
                                message = json.message || lang.unable_to_place_order_order_manually;
                            }
                            this.setState({
                                errorMessage: message
                            })
                            reject()
                        })
                    })
                },
                removeFromUiAfter: 1500,
                autoRetry: !isDisableRetry,
                maxRetryCount: 3,
                name: `Confirm order and close bill to Table ${table.name}`
            }
            PendingQueue.add(a)
        }
        else {
            let otherOptions = {
                ...extraDataFromOptions,
                is_without_close_table: options.is_without_close_table,
            }
            if (options) {
                otherOptions.is_auto_print_receipt = options.is_auto_print_receipt
            }
            me.closeBillApi(table, otherOptions)
        }
    }

    printOrder = () => {
        let orders = this.context.state.adminOrders.filter(order => this.context.state.currentSession && order.table_session_id == this.context.state.currentSession.id )
        let me = this
        let sessionID = orders[0].table_session_id

        $.ajax({
            url: "/merchant/api/order/" + sessionID + "/printbill",
            type: "POST",
            data : {},
            success: (response) => {
            }
        })
    }

    triggerOpenDrawer = () => {
        PrinterFunction.openDrawer()
    }

    openDrawer = () =>{
        let me = this
        let sessionID = this.context.state.currentSession.id

        $.ajax({
            url: "/merchant/api/order/" + sessionID + "/opendrawer",
            type: "POST",
            data : {},
            success: (response) => {
                //Do nothing
            }
        })
    }

    #isDisableRetry = () => {
        const isDisableRetry = window.debugSetting && window.debugSetting.admin_order && window.debugSetting.admin_order.disable_retry
        return isDisableRetry
    }

    closeBillApi = (table, options) => {
        let data = {
            cash: getFinalBillCashValue(this.context.state.bill),
            cash_balance: this.context.state.bill.cash_balance,
            service_charge: this.context.state.bill.service_charge,
            service_charge_percent: this.context.state.bill.service_charge_percent,
            is_auto_print_receipt: (options && options.is_auto_print_receipt) || 0,
            is_without_close_table: (options && options.is_without_close_table) || 0,
            bill_merchant_admin_id: (options && options.bill_merchant_admin_id) || "",
            counter_id: (options && options.counter_id) || null,
            earn_point: options.earn_point,
            redeem_point: options.redeem_point,
            membership_id: options.membership_id,
        }
        const splitBillSelectedOrderId = this.context.state.splitBillSelectedOrderId

        // Pass order to split to another bill
        if (splitBillSelectedOrderId && splitBillSelectedOrderId.length > 0) {
            data["split_bill_selected_order_ids"] = splitBillSelectedOrderId
        }
        let bill = this.context.state.bill
        data.payment_type_id = bill.payment_type_id
        data.ref_no = bill.ref_no || null
        data.discount = bill.discount.value

        let session = this.getSession()
        const sessionId = session.id

        const isDisableRetry = window.debugSetting && window.debugSetting.admin_order && window.debugSetting.admin_order.disable_retry
        const finalData = JSON.parse(JSON.stringify(data))
        let a = {
            action: () => {
                return new Promise((resolve, reject) => {
                    $.ajax({
                        url: `/merchant/api/bill/${sessionId}/settle`,
                        type: "post",
                        data: finalData,
                        success: () => {
                            $(document).trigger("MerchantAppData.closeBillApi.completed")
                            resolve()
                        }
                    })
                    .fail(() => {
                        reject()
                    })
                })
            },
            name: "Close bill to table " + table.name,
            autoRetry: !isDisableRetry,
            maxRetryCount: this.#isDisableRetry() ? 0 : 3,
            removeFromUiAfter: 1500,
        }
        PendingQueue.add(a)
    }

    complete(e, router, otherStates = {}) {
        let closeDialog = () => {
            this.setState({
                ...otherStates,
                adminOrders: [],
                selectedOrder: Object.assign(new OrderItem, {
                    id: -1,
                    itemName: "",
                    itemPrice: "",
                    itemTotal: this.context.state.currencyName ? this.context.state.currencyName+" 0.00" : "RM 0.00"
                }),
                draftOrder: false,

                // This is only valid when user perform settlement without confirm, where we have to wait
                // for newly created table session id before we can proceed with Print button
                newOrderTableSessionId: null,
            })
        }
        closeDialog();
        router.history.push(`/pos`)
    }

    /**
     * Please pass this.props as router. this.context
     * is actually MerchantApp, which do not has access
     * to Router
     *
     * @param {Event} e
     * @param {Object} router
     * @param {function()} callback
     */
    cancelSelectedOrder(e, router, callback) {
        e && e.stopPropagation && e.stopPropagation()

        let order = this.context.state.selectedOrder;

        // Remove the cancelled order from state
        let draft = false
        let adminOrders = this.context.state.adminOrders
        for( var i = 0; i < adminOrders.length; i++) {
            if (adminOrders[i].id == order.id) {
                adminOrders.splice(i, 1)
            }
            else if (adminOrders[i].order_status == "draft") {
                draft = true
            }
        }

        this.setState({
            adminOrders: adminOrders,
            selectedOrder: {
                id: -1,
                itemName: "",
                itemPrice: "",
                itemTotal: this.context.state.currencyName ? this.context.state.currencyName+" 0.00" : "RM 0.00"
            },
            draftOrder: draft
        }, () => {
            callback && callback()
            $(document).trigger("app.admin-orders-cancelled")
        })
        const matchParams = router.match.params
        router.history.push(`/table/${matchParams.tableID}/category/${matchParams.categoryID}`)
    }
}

export default new MerchantAppData();